/*
 * Copyright (c) 2021 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import * as React from "react";
import { Helmet } from "react-helmet";

const googleTagManagerId = process.env.GOOGLE_TAG_MANAGER_ID || "";
const script = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${googleTagManagerId}');`;

export const GoogleTagManagerInit = () =>
  (googleTagManagerId !== "" && (
    <Helmet>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${googleTagManagerId}`}></script>
      <script>{script}</script>
    </Helmet>
  )) ||
  null;
